import { DateUtil } from './index';

export const DEFAULT_ORGANIZATION_TIME_ZONE = 'America/Santiago';

interface CalendarTimeZoneState {
  organizations?: { organization?: { timeZone?: string } };
  user?: { profile?: { data?: { timeZone?: string } } };
}

export const selectCalendarTimeZone = (state: CalendarTimeZoneState): string =>
  state.organizations?.organization?.timeZone ||
  state.user?.profile?.data?.timeZone ||
  Intl.DateTimeFormat().resolvedOptions().timeZone ||
  DEFAULT_ORGANIZATION_TIME_ZONE;

/** Calendar bounds paired with the legacy epoch-second range for compatible dashboard requests. */
export const getCalendarRange = (range: { gte: string; lte: string }, timeZone: string) => ({
  from: DateUtil.toDateString(new Date(Number(range.gte) * 1000), 'YYYY-MM-DD', timeZone),
  to: DateUtil.toDateString(new Date(Number(range.lte) * 1000), 'YYYY-MM-DD', timeZone),
});
